import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';
import useWindowSize from 'hooks/useWindowsSize';
import { IconButton, makeStyles } from '@material-ui/core';
import SelectLanguage from './SelectLanguage';
import Menu from './Menu';

const useStyles = makeStyles({
  root: {
    background: '#15B2DB',
    height: '50px',
    width: '50px',
    borderRadius: '100%',
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25);',
    position: 'absolute',
    right: '25px',
    top: '20px',
  },
});

const Navbar = () => {
  const classes = useStyles();
  const history = useHistory();
  const size = useWindowSize();
  const [scrollY, setScrollY] = useState(null);
  const [openMenu, setOpenMenu] = useState(false);

  const { t } = useTranslation(['rest', 'solutions']);

  const { pathname } = useLocation();

  const dark = pathname !== '/';

  const isMobile = () => size.width <= 1000;

  useEffect(() => {
    window.onscroll = () => {
      setScrollY(window.pageYOffset);
    };

    return () => (window.onscroll = null);
  }, []);

  const handleCloseMenu = () => {
    setOpenMenu(false);
  };

  return openMenu ? (
    <Menu handleCloseMenu={handleCloseMenu} />
  ) : (
    <div
      className={`navbar-header-container ${scrollY >= 200 || dark ? 'navbar-header-dark' : ''} ${
        isMobile() ? 'navbar-header-mobile' : ''
      }`}
    >
      <div className="navbar-container">
        <div className="navbar-logo-container">
          <img
            className="navbar-image-logo"
            src={isMobile() ? 'logo_obd_blue.png' : 'logo_obd.png'}
            onClick={() => history.push('/')}
          />
          <div className="navbar-titles-container">
            <h3 className="navbar-title">{t('solutions:digitalOnboarding.title')}</h3>
            <p className="navbar-subtitle">
              {t('solutions:digitalOnboarding.abbreviatedSubtitle')}
            </p>
          </div>
        </div>
        {!isMobile() ? (
          <div>
            <a className="navbar-link" href="#aboutUs">
              {t('words.aboutUs')}
            </a>
            <a className="navbar-link" href="#industries">
              {t('words.industries').toUpperCase()}
            </a>
            <a className="navbar-link" href="#contactUs">
              {t('words.contactUs')}
            </a>
            <a className="navbar-link" href="#faq">
              {t('words.FAQ')}
            </a>
            <SelectLanguage />
          </div>
        ) : (
          <div onClick={() => setOpenMenu(true)}>
            <IconButton className={classes.root}>
              <img src="assets/img/hamburger-button.svg" />
            </IconButton>
          </div>
        )}
      </div>
    </div>
  );
};

export default Navbar;

Navbar.propTypes = {
  dark: PropTypes.bool,
};

Navbar.defaultProps = {
  dark: false,
};
